import axios from 'axios';
import { createApiConfiguration } from '../api/apiConfig';
import type { EconomicsChangeEntry } from '../types/economicsTypes';

// Applies all Economics changes for a scenario in one atomic backend call.
// Hand-written (rather than via the generated client) so the feature does not depend on
// regenerating the OpenAPI client; the endpoint contract is owned by EconomicsController.
export async function saveEconomicsBatch(
  locationId: string,
  scenarioId: string,
  changes: EconomicsChangeEntry[]
): Promise<void> {
  const config = createApiConfiguration();
  const rawToken = typeof config.accessToken === 'function' ? config.accessToken() : config.accessToken;
  const token = (await Promise.resolve(rawToken)) ?? '';
  const basePath = config.basePath ?? window._env_?.API_BASE_URL ?? '';

  await axios.post(
    `${basePath}/api/location/${locationId}/scenario/${scenarioId}/yearplan/economics/batch`,
    { changes },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
